module.exports = __webpack_public_path__ + "img/stock2.f1e4d5d4.png";